import a from"react";const e=({variation:e="primary",className:r=""})=>a.createElement("div",{className:`loading ${e} ${r}`});export{e as Loading};
//# sourceMappingURL=Loading.js.map
